<ng-container *adaptLoading="!goals">
    @if (hasGoals) {
        <adapt-render-zone-map [verticalLayout]="verticalLayout"
                               [zoneContentTemplate]="zoneContentTemplate"></adapt-render-zone-map>
    } @else {
        <ng-template [ngTemplateOutlet]="noGoalsTemplate"></ng-template>
    }
</ng-container>

<ng-template #zoneMapTemplate>
    <adapt-render-zone-map [verticalLayout]="verticalLayout"
                           [zoneContentTemplate]="zoneContentTemplate"></adapt-render-zone-map>
</ng-template>
<ng-template #zoneContentTemplate
             let-zone>
    <div [froalaView]="contentByZone(zone)"></div>
</ng-template>
